import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

/**
 * Serviço de Gerenciamento de Chaves PIX
 * Utiliza os endpoints Gowd via Higher-API Gateway
 */

/*
  ── O accountId saiu do caminho ──

  Estas chamadas montavam `/v1/baas/accounts/${accountId}/keys`, e essa rota nunca existiu:
  a API expõe `/v1/baas/accounts/keys` e deriva a conta do e-mail autenticado. O resultado
  era 404 em toda criação, listagem e exclusão de chave — e derivar a conta no servidor é o
  que impede um cliente de mexer nas chaves de outro, então o caminho certo também é o
  seguro.
*/
function create(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");
  const clientCode = sessionStorage.getItem("clientCode");

  const payload = {
    type: data?.type || data?.keyType,
    key: data?.key,
  };

  /*
    O canal só acompanha chave de TELEFONE — é por onde o código de confirmação chega (sms
    ou whatsapp). Mandá-lo em chave de outro tipo é recusado pelo servidor, e com razão:
    aceitar faria o cliente esperar um SMS que nunca vem.
  */
  if (payload.type === "PHONE" && data?.channel) {
    payload.channel = data.channel;
  }

  let url = `/v1/baas/accounts/keys?email=${email}`;
  if (clientCode) {
    url += `&clientCode=${clientCode}`;
  }

  return SetupBackend.post(url, payload);
}

/**
 * Confirma o código de uma chave de telefone ou e-mail.
 *
 * Telefone e e-mail não são documentos: o Banco Central exige provar a posse antes de
 * vincular a chave. A criação devolve `validationId` com status PENDING e manda o código
 * para o contato; a chave só passa a existir depois desta confirmação.
 */
function confirm(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.post(
    `/v1/baas/accounts/keys/confirm?email=${encodeURIComponent(email)}`,
    { validationId: data.validationId, code: data.code },
  );
}

function destroy(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");
  const clientCode = sessionStorage.getItem("clientCode");

  const keyId = data?.keyId || data?.key;

  let url = `/v1/baas/accounts/keys/${encodeURIComponent(keyId)}?email=${email}`;
  if (clientCode) {
    url += `&clientCode=${clientCode}`;
  }

  return SetupBackend.delete(url);
}

function index() {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");
  const clientCode = sessionStorage.getItem("clientCode");

  let url = `/v1/baas/accounts/keys?email=${email}`;
  if (clientCode) {
    url += `&clientCode=${clientCode}`;
  }

  return SetupBackend.get(url);
}

/**
 * Consulta uma chave PIX no DICT para obter nome e documento do favorecido.
 * Só se aplica a chave — o DICT não resolve código EMV.
 */
function checkDictKey(key) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.post(
    `/v1/baas/dict/key/check?email=${encodeURIComponent(email)}`,
    { key },
  );
}

const backendServices = {
  create,
  confirm,
  destroy,
  index,
  checkDictKey,
};

export default backendServices;
